import { GoogleLogin } from '@react-oauth/google';
import React from 'react';
import { authenticationService } from "../../services";
//import './GoogleSSO.scss';

class GoogleSSO extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null
        }
    }
    componentDidMount() {
        authenticationService.currentUser.subscribe(x => this.setState({ currentUser: x }));
    }

    decodeJWT = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    }

    render() {
        const responseGoogleSuccess = (credentialResponse) => {
            const decoded = this.decodeJWT(credentialResponse.credential);
            if (decoded) {
                // Create profile object in the old format for compatibility
                const profileObj = {
                    email: decoded.email,
                    imageUrl: decoded.picture,
                    name: decoded.name
                };
                const tokenObj = {
                    id_token: credentialResponse.credential,
                    expires_at: decoded.exp * 1000 // Convert to milliseconds
                };
                authenticationService.login(profileObj, tokenObj);
            }
        }
        const responseGoogleFailure = () => {
            authenticationService.logout();
        }
        return (<>
            <GoogleLogin
                onSuccess={responseGoogleSuccess}
                onError={responseGoogleFailure}
                hosted_domain="instylesolar.com.au"
                text="signin_with"
                shape="rectangular"
                theme="outline"
                size="large"
            />
        </>
        )
    }
}

export default GoogleSSO
